export const colors = {
  primary_base: '#9a9eb5',
  primary_lighten5: '#f6f7fa',
  primary_lighten4: '#edeff5',
  primary_lighten3: '#dce0eb',
  primary_lighten2: '#c9cddd',
  primary_lighten1: '#b2b7ca',
  primary_darken1: '#13141c',
  primary_darken2: '#343548',
  primary_darken3: '#696c86',
  primary_darken4: '#82869f',

  secondary_base: '#ea4859',
  secondary_lighten5: '#f5f0f1',
  secondary_lighten4: '#f5dce0',
  secondary_lighten3: '#f5c3ca',
  secondary_lighten2: '#f2a0ab',
  secondary_lighten1: '#f07987',
  secondary_darken1: '#610b01',
  secondary_darken2: '#8b0a03',
  secondary_darken3: '#b50808',
  secondary_darken4: '#df192c',

  accent_base: '#477DE4',
  accent_lighten5: '#F5F6FA',
  accent_lighten4: '#DCE1F3',
  accent_lighten3: '#C1CDF0',
  accent_lighten2: '#9BB2EC',
  accent_lighten1: '#7498E8',
  accent_darken1: '#010A61',
  accent_darken2: '#031E96',
  accent_darken3: '#083DC7',
  accent_darken4: '#1963E0',

  error_base: '#ea4859',
  error_lighten5: '#f5f0f1',
  error_lighten4: '#f5dce0',
  error_lighten3: '#f5c3ca',
  error_lighten2: '#f2a0ab',
  error_lighten1: '#f07987',
  error_darken1: '#610b01',
  error_darken2: '#8b0a03',
  error_darken3: '#b50808',
  error_darken4: '#df192c',

  success_base: '#47e45b',
  success_lighten5: '#f7f9f4',
  success_lighten4: '#ebf7df',
  success_lighten3: '#d5f5c5',
  success_lighten2: '#b0f3a0',
  success_lighten1: '#7aef78',
  success_darken1: '#016121',
  success_darken2: '#039732',
  success_darken3: '#08be3f',
  success_darken4: '#1ed54e',

  warning_base: '#ede344',
  warning_lighten5: '#f9faf5',
  warning_lighten4: '#f7fbe2',
  warning_lighten3: '#f2f7c5',
  warning_lighten2: '#f2f5a2',
  warning_lighten1: '#f1f078',
  warning_darken1: '#980d00',
  warning_darken2: '#c66906',
  warning_darken3: '#dfa813',
  warning_darken4: '#e9d320',
};
